"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDateOfBirthValid = void 0;
const moment_1 = __importDefault(require("moment"));
const isDateOfBirthValid = (context) => {
    var _a, _b, _c;
    const waitlistDob = (_b = (_a = context.waitlist) === null || _a === void 0 ? void 0 : _a.patient) === null || _b === void 0 ? void 0 : _b.date_of_birth;
    const eventDate = (_c = context.dateOfBirth) === null || _c === void 0 ? void 0 : _c.date;
    if (!waitlistDob || !eventDate)
        return false;
    // Parse dates and ensure we're using UTC to avoid timezone issues
    // For date of birth, we only care about the date component, not time or timezone
    const waitlistMoment = moment_1.default.utc(waitlistDob, 'YYYY-MM-DD').startOf('day');
    // For eventDate, ensure we're also working with just the date in UTC
    // This handles cases where eventDate might include time information
    const eventMoment = moment_1.default.utc(eventDate).startOf('day');
    // Compare dates using moment's isSame method or format to same date string
    return (waitlistMoment.isValid() &&
        eventMoment.isValid() &&
        waitlistMoment.format('YYYY-MM-DD') === eventMoment.format('YYYY-MM-DD'));
};
exports.isDateOfBirthValid = isDateOfBirthValid;
exports.default = {
    isDateOfBirthValid: exports.isDateOfBirthValid
};
//# sourceMappingURL=guards.dobConfirmationMachine.js.map